import * as actionTypes from './actionTypes'
import axios from 'axios'
import {storage} from '../../App'

export const setUser = (user) => dispatch => {
    dispatch({
        type: actionTypes.SET_USER,
        payload: user
    })
}

export const getCategory = (_id,setActive) => dispatch => {
    dispatch({
        type: actionTypes.SET_CATEGORY,
        payload: false
    })
    axios({
        method: "post",
        url: "/getAllCategory", 
        data: {
          userId: _id
        }
    }).then(res => {
        dispatch({
            type: actionTypes.SET_CATEGORY,
            payload: res.data.data
        })

        if(setActive) {
            dispatch({
                type: actionTypes.SET_ACTIVE_CATEGORY,
                payload: res.data.data[res.data.data.length - 1]
            })


            setTimeout(() => {
                dispatch({
                    type: actionTypes.SET_ACTIVE_CATEGORY,
                    payload: false
                })
            },[3000])
        }
    }).catch(err => {
        console.log(err)
    });

}

export const getSeries = (_id,setActive) => dispatch => {
    dispatch({
        type: actionTypes.SET_SERIES,
        payload: false
    })
    axios({
        method: "post",
        url: "/getAllSeries", 
        data: {
          userId: _id
        }
    }).then(res => {
        dispatch({
            type: actionTypes.SET_SERIES,
            payload: res.data.data
        })

        if(setActive) {
            dispatch({
                type: actionTypes.SET_ACTIVE_SERIES,
                payload: res.data.data[res.data.data.length - 1]
            })


            setTimeout(() => {
                dispatch({
                    type: actionTypes.SET_ACTIVE_SERIES,
                    payload: false
                })
            },[3000])
        }
    }).catch(err => {
        console.log(err)
    });
}


export const getParts = (_id,setActive) => dispatch => {
    dispatch({
        type: actionTypes.SET_PARTS,
        payload: false
    })
    axios({
        method: "post",
        url: "/getAllProductPart", 
        data: {
          userId: _id
        }
    }).then(res => {
        dispatch({
            type: actionTypes.SET_PARTS,
            payload: res.data.data
        })

        if(setActive) {
            dispatch({
                type: actionTypes.SET_ACTIVE_PART,
                payload: res.data.data[res.data.data.length - 1]
            })


            setTimeout(() => {
                dispatch({
                    type: actionTypes.SET_ACTIVE_PART,
                    payload: false
                })
            },[3000])
        }
    }).catch(err => {
        console.log(err)
    });
}



export const getGoDown = (_id) => dispatch => {
    dispatch({
        type: actionTypes.SET_GODOWN,
        payload: false
    })
    axios({
        method: "post",
        url: "/getAllGodown", 
        data: {
          userId: _id
        }
    }).then(res => {
        dispatch({
            type: actionTypes.SET_GODOWN,
            payload: res.data.data
        })
    }).catch(err => {
        console.log(err)
    });
}


export const getLocations = (_id) => dispatch => {
    dispatch({
        type: actionTypes.SET_LOCATION,
        payload: false
    })
    axios({
        method: "post",
        url: "/getAllLocation", 
        data: {
          userId: _id
        }
    }).then(res => {
        dispatch({
            type: actionTypes.SET_LOCATION,
            payload: res.data.data
        })
    }).catch(err => {
        console.log(err)
    });
}


export const getTaxes = (_id) => dispatch => {
    dispatch({
        type: actionTypes.SET_TAXES,
        payload: false
    })
    axios({
        method: "post",
        url: "/getAllTax", 
        data: {
          userId: _id
        }
    }).then(res => {
        dispatch({
            type: actionTypes.SET_TAXES,
            payload: res.data.data
        })
    }).catch(err => {
        console.log(err)
    });
}
export const getAllCoupons = (_id) => dispatch => {
    dispatch({
        type: actionTypes.SET_COUPONS,
        payload: false
    })
    axios({
        method: "get",
        url: "/all-coupon", 
        data: {
          userId: _id
        }
    }).then(res => {
        dispatch({
            type: actionTypes.SET_COUPONS,
            payload: res.data.data
        })
    }).catch(err => {
        console.log(err)
    });
}

export const getAllPartner = (_id,setActive) => dispatch => {
    dispatch({
        type: actionTypes.SET_PARTNERS,
        payload: false
    })
    axios({
        method: "post",
        url: "/getAllPartner", 
        data: {
          userId: _id
        }
    }).then(res => {
        dispatch({
            type: actionTypes.SET_PARTNERS,
            payload: res.data.data
        })

        if(setActive) {
            dispatch({
                type: actionTypes.SET_ACTIVE_PARTNER,
                payload: res.data.data[res.data.data.length - 1]
            })


            setTimeout(() => {
                dispatch({
                    type: actionTypes.SET_ACTIVE_PARTNER,
                    payload: false
                })
            },[3000])
        }
    }).catch(err => {
        console.log(err)
    });
}
export const getAllAppUsers = (_id,setActive) => dispatch => {
    dispatch({
        type: actionTypes.SET_APPUSERS,
        payload: false
    })
    axios({
        method: "post",
        url: "/getAllAppUsers", 
        data: {
          userId: _id
        }
    }).then(res => {
        dispatch({
            type: actionTypes.SET_APPUSERS,
            payload: res.data.data
        })

        if(setActive) {
            dispatch({
                type: actionTypes.SET_ACTIVE_APPUSER,
                payload: res.data.data[res.data.data.length - 1]
            })


            setTimeout(() => {
                dispatch({
                    type: actionTypes.SET_ACTIVE_APPUSER,
                    payload: false
                })
            },[3000])
        }
    }).catch(err => {
        console.log(err)
    });
}
export const getAllPartnerRequests = (_id,setActive) => dispatch => {
    dispatch({
        type: actionTypes.SET_PARTNER_REQUESTS,
        payload: false
    })
    axios({
        method: "post",
        url: "/getAllPartnerRequests", 
        data: {
          userId: _id
        }
    }).then(res => {
        dispatch({
            type: actionTypes.SET_PARTNER_REQUESTS,
            payload: res.data.data
        })

        if(setActive) {
            dispatch({
                type: actionTypes.SET_ACTIVE_PARTNER_REQUEST,
                payload: res.data.data[res.data.data.length - 1]
            })


            setTimeout(() => {
                dispatch({
                    type: actionTypes.SET_ACTIVE_PARTNER_REQUEST,
                    payload: false
                })
            },[3000])
        }
    }).catch(err => {
        console.log(err)
    });
}

export const getAllImages = () => dispatch => {
    var storageRef = storage.ref();
    var listRef = storageRef.child('/product-images');

    
    listRef.listAll().then(async function(res) {
        await res.items.forEach(async function(itemRef,index) {
            await itemRef.getDownloadURL().then(url => {
                dispatch(addImage(url))
            })
        });

    }).catch(function(error) {
    
    });   
}

export const addImage = (url) => dispatch => {
    dispatch({
        type: actionTypes.ADD_IMAGE,
        payload: url
    })
}



export const setShowCategory = (bool) => dispatch => {
    dispatch({
        type: actionTypes.SET_ADD_CATEGORY,
        payload: bool
    })
}

export const setShowSeries = (bool) => dispatch => {
    dispatch({
        type: actionTypes.SET_ADD_SERIES,
        payload: bool
    })
}


export const setShowPart = (bool) => dispatch => {
    dispatch({
        type: actionTypes.SET_ADD_PART,
        payload: bool
    })
}

export const setShowPartner = (bool) => dispatch => {
    dispatch({
        type: actionTypes.SET_ADD_PARTNER,
        payload: bool
    })
}